<template>
  <div class="zhuli-banner">
    <a class="row">
      <div class="col col-1"><i class="iconfont icon-xiaolaba"></i>分享给{{kcData.numlimit}}个同行，可{{kcData.expire_day}}天免费学习本课程</div>
      <div class="col col-2">
        <span v-if="kcData.assistance_count">{{kcData.assistance_count > kcData.numlimit ? kcData.numlimit : kcData.assistance_count}} / {{kcData.numlimit}}</span>
        <span v-else="">免费观看</span>
      </div>
    </a>
  </div>
</template>
<script type="text/ecmascript-6">
export default {
  props: {
    kcData: {
      type: Object,
      default: null
    }
  }
}
</script>
<style scoped lang="stylus">
  @import "~common/stylus/variable"
  .zhuli-banner{
    width: 100%;
    position relative;
    padding-bottom: 11.73%;
    a.row{
      position absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-image: url('~common/image/zhuli-banner.png')
      background-repeat: no-repeat
      -webkit-background-size: 100% 100%
      background-size: 100% 100%
      padding: 0 size(30);
      display flex
      flex-direction row
      flex-wrap nowrap
      justify-content space-between
      align-items center
      color #fff;
      font-size: size(28);
      .col-1{
        width 80%;
        i{
          font-size size(30)
          position relative
          top: size(2)
          margin-right: size(10)
        }
        /**i:after{
          content: '';
          display: block;
          position: absolute;
          width: 120%;
          height: 120%;
          top: 0;
          left: 0;
          background-color: red;
          transition: opacity .3s,-webkit-transform .3s;
          transition: opacity .3s,transform .3s;
          transition: opacity .3s,transform .3s,-webkit-transform .3s;
          -webkit-animation: pulse-animation 1s cubic-bezier(0.24, 0, 0.38, 1) infinite;
          animation: pulse-animation 1s cubic-bezier(0.24, 0, 0.38, 1) infinite;
        }*/
      }
      .col-2{
        width: 20%;
        text-align center;
        span{
          display block
          width: 100%;
          background-color: #fff
          color: #ff5045;
          font-size: size(26);
          height: size(42);
          line-height size(42);
          -webkit-border-radius: size(21);
          -moz-border-radius: size(21);
          border-radius: size(21);
        }
      }
    }
  }
  @keyframes pulse-animation {
    0% {
      opacity: 1
      -webkit-transform: scale(1)
      transform:scale(1)
    }
    50% {
      opacity:0
      -webkit-transform:scale(1.5)
      transform:scale(1.5)
    }
    100% {
      opacity:0;
      -webkit-transform:scale(1.5);
      transform:scale(1.5)
    }
  }
  @-webkit-keyframes pulse-animation {
    0% {
      opacity:1;
      -webkit-transform:scale(1);
      transform:scale(1)
    }
    50% {
      opacity:0;
      -webkit-transform:scale(1.5);
      transform:scale(1.5)
    }
    100% {
      opacity:0;
      -webkit-transform:scale(1.5);
      transform:scale(1.5)
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/base/activity/zhuli/banner.vue